import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';
import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CalAngularModule } from '@cvx/cal-angular';
import { environment } from '../environments/environment';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppConfigService } from './core/services/cal-services/app-config.service';
import { AuthInterceptor } from './http_interceptors/auth.interceptor';
import { HttpUtilityService } from './core/services/http.utility.service';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';

registerLocaleData(en);

export function initializeApp(appConfig: AppConfigService) {
  return (): Promise<any> => {
    return appConfig.load();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    //provideClientHydration(),
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideAnimations(),
    importProvidersFrom([
      RouterModule.forRoot(routes),
      AppConfigService,
      HttpUtilityService,
      CalAngularModule.forRoot({
        autoSignIn: true,
        popupForLogin: false,
        cacheLocation: 'localStorage',
        instance: environment.calSettings.instance,
        tenantId: environment.calSettings.tenantId,
        clientId: environment.calSettings.clientId,
        redirectUri: environment.calSettings.redirectUri,
        oidcScopes: environment.calSettings.oidcScopes,
        graphScopes: environment.calSettings.graphScopes,
      }),
    ]),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfigService],
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
  ],
};
